import { render, staticRenderFns } from "./StartBtn.vue?vue&type=template&id=587b7704"
import script from "./StartBtn.vue?vue&type=script&lang=js"
export * from "./StartBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports